import { getIn } from 'seamless-immutable';

export const getCurrentCategoryId = (breadcrumb = []) => getIn(breadcrumb, [breadcrumb?.length - 1, 'id'], '');

export const mergeResults = (oldQnA, newQnA = { questions: [] }) => {
  const { questions: oldQuestions = [] } = oldQnA || {};
  return { ...newQnA, questions: [...oldQuestions, ...newQnA.questions], meta: newQnA.meta };
};

export const formatDate = dateString => {
  if (!dateString) {
    return null;
  }

  const date = new Date(dateString);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

export const formatListQuestionsAndAnswers = ({ data, customer = {} }) => {
  if (!data) {
    return { questions: [], meta: {} };
  }

  const result = getIn(data, ['questions', 'result']) || [];
  const meta = getIn(data, ['questions', 'meta']) || {};
  const hasCustomerQuestion = !!result.find(question => question.owner.id === customer.id);
  const formatted = result.reduce(
    (acc, cur) => {
      const question = {
        id: cur.id,
        question: cur.question,
        createdAt: formatDate(cur.createdAt),
        owner: {
          id: cur.owner.id,
          name: cur.owner.name,
        },
        answer: {
          id: cur.answers[0].id,
          text: cur.answers[0].answer,
          owner: cur.answers[0].owner.name,
          createdAt: formatDate(cur.answers[0].createdAt),
        },
        evaluation: {
          like: cur.answers[0].evaluation.likes,
          dislike: cur.answers[0].evaluation.dislikes,
          rating: cur.answers[0].evaluation.rating,
        },
      };
      return { ...acc, questions: [...acc.questions, question] };
    },
    { questions: [], meta, hasCustomerQuestion }
  );
  return formatted;
};

export const feedbackHelper = async feedbackArgs => {
  const [questionId, answerId, action, likeAnswerAction, dislikeAnswerAction] = feedbackArgs;
  let result = {};
  switch (action) {
    case 'like':
      result = await likeAnswerAction({
        variables: {
          answeredId: answerId,
          questionId,
          type: 'like',
        },
      });
      break;
    case 'dislike':
      result = await dislikeAnswerAction({
        variables: {
          answeredId: answerId,
          questionId,
          type: 'dislike',
        },
      });
      break;
  }

  return result?.data?.feedbackQuestion.validationErrors;
};

export const getCustomerQuestions = data => {
  const questions = data.questions?.result;

  if (!questions) {
    return [];
  }

  const customerQuestionsFormatted = questions.reduce((acc, currentQuestion) => {
    if (isDateOlderThan(currentQuestion.createdAt)) {
      return acc;
    }

    const question = {
      createdAt: formatDate(currentQuestion.createdAt),
      question: currentQuestion.question,
      answer: {
        text: currentQuestion.answers[0] && currentQuestion.answers[0].answer,
        createdAt: currentQuestion.answers[0] && formatDate(currentQuestion.answers[0].createdAt),
        owner: currentQuestion.answers[0] && currentQuestion.answers[0].owner.name,
      },
      owner: {
        id: currentQuestion.owner.id,
      },
    };

    return [...acc, question];
  }, []);

  return customerQuestionsFormatted;
};

export const isDateOlderThan = (dateToCompare, numberOfDays = 30) => {
  const now = new Date();
  const questionDate = new Date(dateToCompare);

  return (now.getTime() - questionDate.getTime()) / 86400000 > numberOfDays;
};

export const createDate = (number = 0) => {
  const dateNow = new Date();
  const getHour = dateNow.getHours() + number;

  dateNow.setHours(getHour);
  return dateNow;
};
